// eslint-disable-next-line import/no-duplicates
import { parseISO } from 'date-fns';
import { format, utcToZonedTime } from 'date-fns-tz';
// eslint-disable-next-line import/no-duplicates
import { ptBR } from 'date-fns/locale';

export const formatInTimeZone = (date: string, fmt: string, tz = 'UTC') => {
  const parsedTime = parseISO(date);
  return format(utcToZonedTime(parsedTime, tz), fmt, { timeZone: tz });
};

export const formatInTimeZoneBr = (date: string, fmt: string, tz = 'UTC') => {
  const parsedTime = parseISO(date);
  return format(utcToZonedTime(parsedTime, tz), fmt, {
    timeZone: tz,
    locale: ptBR,
  });
};
